<template>
  <div class="reset-password-container" :class="containerWidth">
    <GauravImpexLogo class="justify-center" :variant="appLogoVariant" />
    <div class="description primary--text text-center mb-3">
      Reset Password
    </div>
    <div v-if="!isPasswordSent" class="section-1">
      <div class="mini-description text-center mb-3">
        Please enter your new password for <b> {{ userEmail }} </b>
      </div>
      <ValidationObserver @keydown.tab="focusNext" v-slot="{ passes }">
        <v-row>
          <v-col cols="12" :xs="12" :sm="12">
            <TextField
              v-model="password"
              showIcons
              rules="required"
              :loading="isResetPasswordFormLoading"
              label="Password"
              placeholder="••••••••"
              type="password"
            />
          </v-col>
          <v-col cols="12" :xs="12" :sm="12">
            <TextField
              v-model="confirmPassword"
              showIcons
              rules="required|confirmed:Password"
              :loading="isResetPasswordFormLoading"
              label="Confirm Password"
              placeholder="••••••••"
              type="password"
            />
          </v-col>
        </v-row>
        <v-btn
          large
          color="button-primary"
          class="white--text my-2"
          block
          :loading="isResetPasswordFormLoading"
          @click="passes(resetPassword)"
        >
          <span class="font-weight-bold fs-15">Reset Password</span>
        </v-btn>
      </ValidationObserver>
    </div>
    <div v-else class="section-2 text-center mt-5">
      <v-card class="pa-3">
        We have sent a reset link to your email ID, please click your email to continue.
      </v-card>
      <v-btn color="primary" @click="resetPassword" :loading="isResetPasswordFormLoading" text class="mt-5">
        Resend Link
      </v-btn>
    </div>
  </div>
</template>
<script>
import GauravImpexLogo from "@/components/GauravImpexLogo";
import { ValidationObserver } from "vee-validate";
import TextField from "@/components/TextField";
import { VERIFY_TOKEN } from "@/modules/AuthModule/store/actionTypes";
import { RESET_PASSWORD } from "@/modules/AuthModule/store/actionTypes";
import commonMethodsMixin from "@/modules/commonMethodsMixin";
export default {
  name: "ResetPassword",
  components: {
    GauravImpexLogo,
    ValidationObserver,
    TextField
  },
  data() {
    return {
      password: "",
      confirmPassword: "",
      isResetPasswordFormLoading: false,
      isPasswordSent: false,
      userEmail: ""
    };
  },
  mounted() {
    this.verifyToken();
  },
  mixins: [commonMethodsMixin],
  methods: {
    verifyToken() {
      this.isResetPasswordFormLoading = true;
      this.$store
        .dispatch(VERIFY_TOKEN, {
          token: this.$route.params.reset
        })
        .then(res => {
          if (res) {
            this.userEmail = res.data.token.email;
          }
        })
        .catch(err => {
          if (err && err.data.message === "Invalid Token") {
            this.$router.push({ name: "404" });
            return;
          }
          this.handleError(err);
        })
        .finally(() => {
          this.isResetPasswordFormLoading = false;
        });
    },
    resetPassword() {
      this.isResetPasswordFormLoading = true;
      this.$store
        .dispatch(RESET_PASSWORD, {
          token: this.$route.params.reset,
          password: this.password,
          password_confirmation: this.confirmPassword
        })
        .then(res => {
          if (res && res.message === "success") {
            this.$router.push({ name: "auth.login" });
            // location.replace(res.redirectUrl);
          }
        })
        .catch(err => {
          this.handleError(err);
        })
        .finally(() => {
          this.isResetPasswordFormLoading = false;
        });
    },
    navigateToLoginPage() {
      this.$router.push({ name: "auth.login" });
    }
  }
};
</script>
<style lang="scss">
.reset-password-container {
  margin: auto;

  .description {
    font-size: 1.3rem;
    font-weight: 600;
  }

  .section-2 {
    .v-card {
      box-shadow: 0px 10px 40px rgba(0, 0, 0, 0.16);
    }
  }

  .form-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}
</style>
